import { CommonEventsEnum } from '@hubxtech/hubx-client-analytics-package/lib/src/enum/common/commonEventsEnum';

import { hubxAnalytic } from '@/lib/analytics/services/analytics';

type HubxEventPayload = Parameters<typeof hubxAnalytic.sendEvent>[0];

type RuntimeHubxAnalytic = {
  getHubxId?: () => string;
  pauseEventSending?: boolean;
  send?: (eventPayload: HubxEventPayload & { hubx_id?: string }) => void;
};

function getRecord(value: unknown): Record<string, unknown> | undefined {
  if (!value || typeof value !== 'object') {
    return undefined;
  }

  return value as Record<string, unknown>;
}

function hasOriginEntryPoint(payload: HubxEventPayload): boolean {
  const eventParams = getRecord(
    (payload as { event_params?: unknown }).event_params
  );
  const source = getRecord(eventParams?.source);
  const origin = getRecord(source?.origin);

  return typeof origin?.entryPoint === 'string';
}

function shouldBypassPackageValidation(payload: HubxEventPayload): boolean {
  return (
    payload.eventName === CommonEventsEnum.LND_PAYWALL &&
    hasOriginEntryPoint(payload)
  );
}

export async function sendHubxEventPayload(
  payload: HubxEventPayload
): Promise<void> {
  const runtimeHubxAnalytic = hubxAnalytic as unknown as RuntimeHubxAnalytic;

  if (
    shouldBypassPackageValidation(payload) &&
    runtimeHubxAnalytic.pauseEventSending !== true &&
    typeof runtimeHubxAnalytic.send === 'function' &&
    typeof runtimeHubxAnalytic.getHubxId === 'function'
  ) {
    runtimeHubxAnalytic.send({
      ...payload,
      hubx_id: runtimeHubxAnalytic.getHubxId(),
    });
    return;
  }

  await hubxAnalytic.sendEvent(payload);
}
